/**
 * Widget key for the Toado-on-Toado dogfood widget (the widget embedded in
 * the Toado app itself, so we can report Toado bugs with Toado).
 *
 * Prefers a build-time override — `VITE_TOADO_WIDGET_KEY`, e.g. a developer
 * pointing at their own LOCAL widget — and falls back to the live "toado
 * testing" project's key so the dogfood widget ships to prod without needing
 * a per-deploy env var set on DigitalOcean.
 *
 * The key is PUBLIC by design (it ships in the page source of every embed and
 * authorizes only "submit a report to this one project"), so hard-coding it
 * here is not a secret leak. The widget stays staff/dev-gated by its
 * consumers (DogfoodWidget, TopBar), so customers never see it.
 *
 * Local note: with no env override, this prod key is fetched against the
 * LOCAL api, which does not have that widget, so the config fetch 404s and
 * nothing renders — harmless. Set VITE_TOADO_WIDGET_KEY to a local widget key
 * to dogfood locally.
 */
export const DOGFOOD_WIDGET_KEY: string =
  (import.meta.env.VITE_TOADO_WIDGET_KEY as string | undefined)
  || 'wgt_live_wdWkSyE3dmPCxWCMCiTUsfsUpJy6PTkB';
